<template>
  <span class="id-desc">
    <span class="id-desc__id">{{ id }}</span>
    <span class="id-desc__sep" v-if="id !== null && id !== '' && descricao">·</span>
    <span class="id-desc__desc" v-if="descricao">{{ descricao }}</span>
  </span>
</template>

<script>
export default {
  name: "IdDescricaoLabel",
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    descricao: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.id-desc {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #344054;
  line-height: 1.3;
}

.id-desc__id {
  font-weight: 600;
  color: #3a3e81;
  font-variant-numeric: tabular-nums;
}

.id-desc__sep {
  color: #98a2b3;
  font-weight: 400;
}

.id-desc__desc {
  color: #344054;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
